import { useEffect, useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { NetworkingFormData } from '../../NetworkingForm';
import { EditNicFormOriginalValues } from '../utils/utils';

type UseEditNicTrunkedModeParams = {
  watch: UseFormMethods<NetworkingFormData>['watch'];
  setValue: UseFormMethods<NetworkingFormData>['setValue'];
  trigger: UseFormMethods<NetworkingFormData>['trigger'];
  originalValues: EditNicFormOriginalValues;
  onTrunkedDisabled: (networkName: string) => void;
};

export const useEditNicTrunkedMode = ({
  watch,
  setValue,
  trigger,
  originalValues,
  onTrunkedDisabled,
}: UseEditNicTrunkedModeParams): boolean => {
  const watchTrunked = watch('trunked');
  const isTrunked = watchTrunked === true;
  const prevTrunkedRef = useRef(watchTrunked);

  useEffect(() => {
    if (prevTrunkedRef.current === true && !isTrunked) {
      const networkName = originalValues.trunked
        ? ''
        : originalValues.networkName ?? '';

      setValue('assignDhcp', originalValues.assignDhcp ?? false, {
        shouldValidate: true,
      });
      setValue('ipAddress', originalValues.ipAddress ?? '', {
        shouldValidate: true,
      });
      setValue('networkName', networkName, { shouldValidate: true });
      setValue('trunkedNetworks', [], { shouldValidate: true });
      onTrunkedDisabled(networkName);
      trigger(['networkName', 'ipAddress', 'trunkedNetworks', 'assignDhcp']);
    } else if (prevTrunkedRef.current === false && isTrunked) {
      trigger(['trunkedNetworks', 'networkName', 'ipAddress']);
    }

    prevTrunkedRef.current = watchTrunked;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchTrunked, setValue, isTrunked, trigger]);

  return isTrunked;
};
